/** Общая поверхность нижней навигации и свёрнутого разговора. */
export const floatingBarSurface = {
  bg: 'bg.glass',
  backdropFilter: 'blur(14px) saturate(130%)',
  WebkitBackdropFilter: 'blur(14px) saturate(130%)',
  borderRadius: 'l3',
  borderWidth: '1px',
  borderColor: 'border',
  boxShadow: 'overlay',
} as const;
